import React from "react";
import { cn } from "@/utils/utils";
import { DirectoryTeam } from "@/modules/hub/features/EmployeeDirectory/api/fetchEmployeeDirectoryTeams/types";
import { ALL_TEAMS_FILTER } from "@/modules/hub/features/EmployeeDirectory/hooks/useEmployeeDirectoryPage";

interface TeamTabsProps {
  teams: DirectoryTeam[];
  activeTeamUuid: string;
  onChange: (uuid: string) => void;
}

const TeamTabs: React.FC<TeamTabsProps> = ({
  teams,
  activeTeamUuid,
  onChange,
}) => {
  const renderTab = (uuid: string, label: string) => {
    const isActive = activeTeamUuid === uuid;
    return (
      <button
        className={cn(
          "flex items-center gap-2 px-1 py-3 -mb-px border-b-2 text-base transition-colors",
          isActive
            ? "border-primary text-primary font-medium"
            : "border-transparent text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white",
        )}
        key={uuid}
        onClick={() => onChange(uuid)}
        type="button"
      >
        <span>{label}</span>
      </button>
    );
  };

  return (
    <div className="flex flex-wrap items-center gap-x-8">
      {renderTab(ALL_TEAMS_FILTER, "All")}
      {teams.map((team) => renderTab(team.uuid, team.name))}
    </div>
  );
};

export default TeamTabs;
